import { FC, useReducer } from 'react';
import {CTAButton} from 'src/common/components/Button';
import { Modal } from 'src/common/components/Modal';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { VerificationStatus } from 'src/common/models/verificationModels';
import { handleRedirect } from 'src/common/services/process';
import { media } from 'src/common/styles/breakpoints';
import { VerificationReportForm } from 'src/pages/VerificationPage/components/VerificationPageActions/VerificationReportForm';
import {
  SecondaryText,
  SubsectionTitle,
} from 'src/pages/VerificationPage/components/VerificationPageFlow/VerificationPageSuccessPageFlow.styled';
import { useRedirectUrlQuery } from 'src/pages/VerificationPage/verificationQueries';
import { useWebSdk } from 'src/webSdk/useWebSdk';
import styled, { css } from 'styled-components';

const StyledModalContent = styled.div`
  display: grid;
  grid-template-rows: 7.75rem 1fr;
  grid-row-gap: 1rem;

  ${media.w.min.px576(css`
    grid-template-rows: 5.8125rem 1fr;
    grid-row-gap: 2rem;
  `)}
`;

const ModalSubsectionTitle = styled(SubsectionTitle)`
  opacity: 1;
  ${media.w.max.px576(css`
    margin: 0 0.75rem;
  `)}
`;

interface VerificationPageActionsProps {
  status?: VerificationStatus;
}

export const VerificationPageActions: FC<VerificationPageActionsProps> = ({
  status,
}) => {
  const id = useVerificationId();
  const webSdk = useWebSdk();

  const [reportModalOpen, toggleReportModal] = useReducer(
    (prev) => !prev,
    false
  );

  const redirectUrlForProcess = useRedirectUrlQuery(id);

  return (
    <>
      <Modal
        open={reportModalOpen}
        onClose={toggleReportModal}
        title="Podaj adres email do wysyłki raportu"
      >
        <StyledModalContent>
          <ModalSubsectionTitle>
            Na podany poniżej adres email wyślemy Twój raport z weryfikacji,
            upewnij się więc, że jest on prawidłowy.
          </ModalSubsectionTitle>
          <VerificationReportForm onModalClose={toggleReportModal} />
        </StyledModalContent>
      </Modal>
      <CTAButton
        disabled={
          !status ||
          ![VerificationStatus.Done, VerificationStatus.Expired].includes(
            status
          )
        }
        onClick={() => {
          webSdk?.eventHandlers?.onProcessCompleted?.() ||
            handleRedirect(redirectUrlForProcess.data?.redirectUrl);
        }}
      >
        Przejdź dalej
      </CTAButton>
      <SecondaryText>
        Nastąpi przekierowanie do instytucji weryfikującej.
      </SecondaryText>
      {status && [VerificationStatus.Done].includes(status) && (
        <SecondaryText>
          <br />
          Możesz także otrzymać wynik analizy w postaci raportu&nbsp;PDF.{' '}
          <u onClick={toggleReportModal}>Wyślij raport na adres email.</u>
        </SecondaryText>
      )}
    </>
  );
};
